import {
  GET_BLOG_POSTS,
  GET_BLOG_POSTS_LOADING,
  GET_BLOG_POSTS_CATEGORIES,
  GET_BLOG_POSTS_CATEGORIES_LOADING,
  GET_BLOG_POST_DETAILS_LOADING,
  GET_BLOG_POST_DETAILS,
  FAILED_BLOG_POST_DETAILS,
  GET_BLOG_RELATED_POSTS,
  GET_BLOG_RELATED_POSTS_LOADING,
  GET_BLOG_AUTHOR,
  GET_BLOG_AUTHOR_LOADING,
} from '../config/actionTypes';

export function blogPosts(state = {}, action) {
  switch (action.type) {
    case GET_BLOG_POSTS:
      return {
        blogPosts: action.blogPosts,
        loading: action.loading,
      };
    case GET_BLOG_POSTS_LOADING:
      return {
        blogPosts: action.blogPosts,
        loading: action.loading,
      };
    default:
      return state;
  }
}

export function blogPostsCategories(state = {}, action) {
  switch (action.type) {
    case GET_BLOG_POSTS_CATEGORIES:
      return {
        blogPostsCategories: action.blogPostsCategories,
        loading: action.loading,
      };
    case GET_BLOG_POSTS_CATEGORIES_LOADING:
      return {
        blogPostsCategories: action.blogPostsCategories,
        loading: action.loading,
      };
    default:
      return state;
  }
}

export function blogPostDetails(state = {}, action) {
  switch (action.type) {
    case GET_BLOG_POST_DETAILS:
      return {
        blogPostDetails: action.blogPostDetails,
        loading: action.loading,
      };
    case GET_BLOG_POST_DETAILS_LOADING:
      return {
        blogPostDetails: action.blogPostDetails,
        loading: action.loading,
      };
    case FAILED_BLOG_POST_DETAILS:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function blogRelatedPosts(state = {}, action) {
  switch (action.type) {
    case GET_BLOG_RELATED_POSTS_LOADING:
      return { posts: undefined, loading: true };
    case GET_BLOG_RELATED_POSTS:
      return { posts: action.posts, loading: false };
    default:
      return state;
  }
}

export function blogAuthor(state = {}, action) {
  switch (action.type) {
    case GET_BLOG_AUTHOR_LOADING:
      return { author: undefined, loading: true };
    case GET_BLOG_AUTHOR:
      return { author: action.author, loading: false };
    default:
      return state;
  }
}
